var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowsRightFilledGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4049_2747)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2908 4.49498C15.0119 4.21603 14.5596 4.21603 14.2807 4.49498C14.0017 4.77392 14.0017 5.22618 14.2807 5.50513L18.0613 9.28577H1.21429C0.819797 9.28577 0.5 9.60556 0.5 10.0001C0.5 10.3945 0.819797 10.7143 1.21429 10.7143H18.0613L14.2807 14.495C14.0017 14.7739 14.0017 15.2262 14.2807 15.5051C14.5596 15.7841 15.0119 15.7841 15.2908 15.5051L20.2908 10.5051C20.3735 10.4224 20.4317 10.3245 20.4654 10.2204C20.4787 10.1793 20.4884 10.1365 20.4941 10.0926C20.502 10.0312 20.502 9.96894 20.4941 9.90755C20.4884 9.86356 20.4787 9.82083 20.4654 9.77972C20.4317 9.6756 20.3735 9.57767 20.2908 9.49498L15.2908 4.49498Z",
    fill: "#00000042"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4049_2747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsRightFilledGray);
export default __webpack_public_path__ + "static/media/arrows-right-filled-gray.a448b3039124ad85752c265c4284304f.svg";
export { ForwardRef as ReactComponent };